module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAwAAAAMCAYAAABWdVznAAAAYElEQVQoU2NkwAJSU1PVGBkZ2WfNmnUZXZoRm4a0tDQbBgaGNUxMTH4zZsw4hawGqwaQgvT0dI////8vQNeEUwMuTXg1YNNEUAOyJgYGBlfqa0D3PPU8TVKwkhxx+JIGAPAxTMt5G8k5AAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/branch-arrow-right.png
// module id = /7oj
// module chunks = 1